import { Link } from "react-router-dom";

interface BrandLogoProps {
  className?: string;
  imgClassName?: string;
  linkClassName?: string;
  showAsLink?: boolean;
}

export const BrandLogo = ({ 
  className = "", 
  imgClassName = "h-28 w-auto", 
  linkClassName = "flex items-center",
  showAsLink = true 
}: BrandLogoProps) => {
  const logoContent = (
    <img 
      src="/lovable-uploads/751b1e4a-f950-493e-b42d-0f435406f664.png" 
      alt="The PEO App Logo" 
      className={imgClassName}
    />
  );

  if (showAsLink) {
    return (
      <div className={className}>
        <Link to="/" className={linkClassName}>
          {logoContent}
        </Link>
      </div>
    );
  }

  return (
    <div className={`${className} ${linkClassName}`}>
      {logoContent}
    </div>
  );
};